import { render, staticRenderFns } from "./DsfrEmail.vue?vue&type=template&id=f0c14ca0&"
import script from "./DsfrEmail.vue?vue&type=script&lang=js&"
export * from "./DsfrEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports